import React from 'react';
import { 
  Box, 
  Modal, 
  Typography, 
  IconButton
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import ContactForm from './ContactForm';

const ModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '98%',
  maxWidth: 1200,
  backgroundColor: '#FFFFFF',
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  padding: theme.spacing(4),
  maxHeight: '90vh',
  overflowY: 'auto',
  [theme.breakpoints.down('md')]: {
    width: '98%',
    padding: theme.spacing(3),
  },
  '&::-webkit-scrollbar': {
    width: '8px'
  },
  '&::-webkit-scrollbar-track': {
    background: '#F1F5F9'
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#CBD5E1',
    borderRadius: '4px',
    '&:hover': {
      background: '#94A3B8'
    }
  }
}));

const ContactModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="contact-modal"
      aria-describedby="contact-form"
    >
      <ModalContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography 
            variant="h5" 
            sx={{ 
              color: '#1A365D',
              fontWeight: 600,
              fontSize: '1.5rem'
            }}
          >
            Contactez-nous
          </Typography>
          <IconButton 
            onClick={onClose}
            sx={{ 
              color: '#64748B',
              '&:hover': { 
                color: '#475569',
                backgroundColor: '#F1F5F9'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <ContactForm onSubmitSuccess={onClose} />
      </ModalContent>
    </Modal>
  );
};

export default ContactModal;
